import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

export default function Layout() {
  return (
    <div className="min-h-screen bg-paper">
      {/* Header - mobile only */}
      <Header />

      <div className="flex">
        {/* Sidebar - desktop (lg and up) */}
        <Sidebar />

        {/* Main content */}
        <main className="min-w-0 flex-1 px-5 pb-32 pt-5 md:px-8 md:pt-8 lg:pb-10 lg:px-10">
          <div className="mx-auto max-w-5xl">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Floating tab bar - mobile */}
      <BottomNav />
    </div>
  );
}
